import React from 'react';
import { Input } from '../Shared/small_components';

const OTPScreen = (props) => {
    const {loginUserOTP } = props;

    return (
        <div className="main-wrapper section" id="main-wrapper">
            <div className="dashboard-wrap section desktop">
                <div className="dashboard-wrap section ptb-5" id="dash">
                    <div className="container" id="main">
                        <div
                            className="row loginPanel"
                            style={{
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                            id="panel-id"
                        >
                            <h3 style={{ marginTop: '20px', fontSize: '36px' }} id="h2-id">
                                Welcome to the Cubefunder Customer Portal{' '}
                            </h3>
                            <h4
                                style={{
                                    marginTop: '8px',
                                    fontSize: '20px',
                                    marginBottom: '20px',
                                }}
                                id="h4-id"
                            >
                                Too Many Attempts, Enter the OTP sent to your mobile number
									</h4>
                            <div
                                style={{
                                    width: '80%',
                                    marginLeft: '10%',
                                    marginTop: '10%',
                                }}
                                id="heading-id"
                            >
                                <div className="form-group" id="form-id">
                                    <Input
                                        label="OTP"
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        id={'otp'}
                                    />
                                </div>
                                <div style={{ textAlign: 'right' }} id="button-id">
                                    <button
                                        className="btn-main black"
                                        style={{ marginRight: '5px' }}
                                        onClick={() =>
                                            {window.location='/Login';}
                                        }
                                    >
                                        Back
											</button>
                                    <div className="btn-main" onClick={() => loginUserOTP('desktop')}>
                                        <span>LOGIN</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dashboard-wrap section mobile">
                <div className="dashboard-wrap section ptb-5" id="dash">
                    <div className="container" id="main">
                        <div
                            className="row loginPanelMobile"
                            style={{
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                            id="panel-id"
                        >
                            <h3 style={{ marginTop: '3%', fontSize: '20px' }} id="h2-id">
                                Welcome to the Cubefunder Customer Portal{' '}
                            </h3>
                            <h4
                                style={{ marginTop: '8px', fontSize: '15px' }}
                                id="h4-id"
                            >
                                Too Many Attempts, Enter the OTP sent to your mobile number
									</h4>
                            <div
                                style={{
                                    width: '80%',
                                    marginLeft: '10%',
                                    marginTop: '10%',
                                }}
                                id="heading-id"
                            >
                                <div className="form-group" id="form-id">
                                    <Input
                                        label="OTP"
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        id={'otpMob'}
                                    />
                                </div>
                                <div style={{ textAlign: 'right' }} id="button-id">
                                    <button
                                        className="btn-main black"
                                        style={{ marginRight: '5px' }}
                                        onClick={() =>
                                            {window.location='/Login';}
                                        }
                                    >
                                        Back
											</button>
                                    <div className="btn-main" onClick={() => loginUserOTP('mobile')}>
                                        <span>LOGIN</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OTPScreen;